<template>
  <div class="mode-switcher">
    <v-tabs
      v-model="tabSelected"
      :centered="true"
      :grow="true"
      @change="toggleMode"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab>
        Manage
      </v-tab>
      <v-tab>
        Mentor
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
import User from "@/lib/user"

export default {
  data: function() {
    return {
      tabSelected: 0
    }
  },
  computed: {
    userId: {
      get() {
        return this.$store.getters["globals/getMenteeId"]
      }
    },
    storeUserMode() {
      return this.$store.getters["globals/getUserMode"]
    }
  },
  methods: {
    toggleMode() {
      var modeString = this.tabSelected == 0 ? "MANAGE" : "MENTOR"
      this.$store.commit("globals/setUserMode", modeString)

      // update route
      var newRouteName = ""
      if (this.$route.name.includes("Mentor")) {
        newRouteName = this.$route.name.replace("Mentor", "Manager")
      } else if (this.$route.name.includes("Manager")) {
        newRouteName = this.$route.name.replace("Manager", "Mentor")
      }

      if (
        !this.$router.options.routes.map(el => el.name).includes(newRouteName)
      ) {
        newRouteName = "default"
      }
      // let userId = this.$store.getters["globals/getMenteeId"]

      this.$router.push(
        {
          name: newRouteName,
          params: { id: this.userId }
        },
        null,
        aborted => {
          // Ignore navigationDuplicated!
        }
      )
    }
  },
  watch: {
    storeUserMode: function(newValue, oldValue) {
      this.tabSelected = newValue == "MANAGE" ? 0 : 1
    }
  },
  created() {
    let userMode = this.$store.getters["globals/getUserMode"]
    this.tabSelected = userMode == "MANAGE" ? 0 : 1
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.mode-switcher {
  margin: 20px;
  width: 216px;
}

.v-tab {
  background-color: $nav-background;
}
</style>
